import {PanelExpandable} from "@pg-design/expandable-module";
import {listUnStyled, m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {ArticleCategoriesLinksItem} from "./ArticleCategoriesLinksItem";

export interface IProps {
    title?: string;
    links: {
        name: string;
        suffix: string;
    }[];
    customFirstElement?: {
        name: string;
        url: string;
    };
    className?: string;
}

export const ArticleCategoriesLinksGroup = (props: IProps) => {
    return (
        <PanelExpandable
            title={
                <Text as="span" variant="headline_6">
                    {props.title}
                </Text>
            }
            alwaysOpen
            className={props.className}
        >
            <ul css={[listUnStyled, p(0), m(0)]}>
                {props.links.map((link, index) => (
                    <ArticleCategoriesLinksItem key={index} link={{name: link.name, url: rpAppLink.article.category({categorySlug: link.suffix})}} />
                ))}
            </ul>
        </PanelExpandable>
    );
};
import {PanelExpandable} from "@pg-design/expandable-module";
import {listUnStyled, m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {ArticleCategoriesLinksItem} from "./ArticleCategoriesLinksItem";

export interface IProps {
    title?: string;
    links: {
        name: string;
        suffix: string;
    }[];
    customFirstElement?: {
        name: string;
        url: string;
    };
    className?: string;
}

export const ArticleCategoriesLinksGroup = (props: IProps) => {
    return (
        <PanelExpandable
            title={
                <Text as="span" variant="headline_6">
                    {props.title}
                </Text>
            }
            alwaysOpen
            className={props.className}
        >
            <ul css={[listUnStyled, p(0), m(0)]}>
                {props.links.map((link, index) => (
                    <ArticleCategoriesLinksItem key={index} link={{name: link.name, url: rpAppLink.article.category({categorySlug: link.suffix})}} />
                ))}
            </ul>
        </PanelExpandable>
    );
};
